module.exports = __webpack_public_path__ + "static/media/present_christmas_map_important.45f6d6e8.svg";